import React, { useState } from "react";

// Material UI
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";

// Axios
import { getResultByID } from "../../services/resultado";

// Redux
import { selectToken } from "../../storeConfig/reducers/loginReducer";
import { useSelector } from "react-redux";

import { calcularGrauDeInovacaoGeral } from "../../assets/utils/calcularGrauInovação";

// ReactChartJs
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

const options = {
	responsive: true,
	maintainAspectRatio: true,
	plugins: {
		legend: {
			display: false,
		},
		layout: {
			autoPadding: true,
		},
		title: {
			display: true,
			text: "Grau de Inovação",
			font: {
				size: 15
			},
		},
	},
	elements: {
		point: {
			hitRadius: "2",
		},
	},
	scale: {
		display: false,
		min: 0,
		max: 5,
	},
	ticks: {
		beginAtZero: true,
		stepSize: 1,
		count: 5,
	},
	scales: {
		x: {
            ticks: {
                font: {
                    size: 15,
                }
            }
        },
		y: {
            ticks: {
                font: {
                    size: 15,
                }
            }
        }
	},
};

function EvolucaoBarra({ listaResultados }) {
	const token = useSelector(selectToken);

	const chartInitialState = {
		labels: [],
		datasets: [
			{
				label: "Grau de Inovação",
				data: [],
				backgroundColor: [],
			},
		],
	};

	const [chartData, setChartData] = useState(chartInitialState);
	const [isLoading, setIsLoading] = useState(false);
	const [checked, setChecked] = useState([]);

	function randomRGBA() {
		var num = Math.round(0xffffff * Math.random());
		var r = num >> 16;
		var g = (num >> 8) & 255;
		var b = num & 255;
		var a = 0.3;
		return "rgba(" + r + ", " + g + ", " + b + "," + a + ")";
	}

	const handleChartData = (id) => {
		setIsLoading(true);
		getResultByID(token, id)
			.then((r) => {
				let { EMI, GGPI, AIO, IGC, PG } = r.data.resultado;

				let GI = calcularGrauDeInovacaoGeral(EMI, GGPI, AIO, IGC, PG);

				let dataResultado = new Date(r.data.data_resultado);

				let dataR = dataResultado.toLocaleDateString("pt-BR");
				let horaR = dataResultado.toLocaleTimeString("pt-BR");

				let chartLabel = `${dataR} ${horaR}`;

				let color = randomRGBA();

				setChartData({
					labels: [...chartData.labels, chartLabel],
					datasets: [
						{
							...chartData.datasets[0],
							data: [
								...chartData.datasets[0].data,
								GI.float.toPrecision(2),
							],
							backgroundColor: [
								...chartData.datasets[0].backgroundColor,
								color,
							],
						},
					],
				});

				setIsLoading(false);
			})
			.catch((e) => {
				console.log(e);
				setIsLoading(false);
			});
	};

	const handleRemoveChartData = (currentIndex) => {
		const newLabels = [...chartData.labels];
		newLabels.splice(currentIndex, 1);
		const newData = [...chartData.datasets[0].data];
		newData.splice(currentIndex, 1);
		const newBackgroundColor = [...chartData.datasets[0].backgroundColor];
		newBackgroundColor.splice(currentIndex, 1);

		setChartData({
			labels: newLabels,
			datasets: [
				{
					...chartData.datasets[0],
					data: newData,
					backgroundColor: newBackgroundColor,
				},
			],
		});
	};

	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);

			handleChartData(value);
		} else {
			newChecked.splice(currentIndex, 1);
			handleRemoveChartData(currentIndex);
		}

		setChecked(newChecked);
	};

	return (
		<>
			<div className="row">
				{/* Listar Resultados */}
				<div className="lista-resultados col-md-12 col-lg-3">
					<FormControl>
						<FormLabel component="div">
							<div className="row">
								<div className="col">Selecione:</div>
								<div className="col">
									{isLoading && (
										<CircularProgress size={25} />
									)}
								</div>
							</div>
						</FormLabel>

						<FormGroup>
							<List>
								{listaResultados.map((item) => {
									const labelId = `checkbox-list-label-${item.id}`;

									let dataResultado = new Date(
										item.data_resultado
									);

									let dataR =
										dataResultado.toLocaleDateString(
											"pt-BR"
										);
									let horaR =
										dataResultado.toLocaleTimeString(
											"pt-BR"
										);

									return (
										<ListItem divider key={item.id}>
											<ListItemButton
												role={undefined}
												onClick={handleToggle(item.id)}
												dense
											>
												<ListItemIcon>
													<Checkbox
														edge="start"
														checked={
															checked.indexOf(
																item.id
															) !== -1
														}
														tabIndex={-1}
														disableRipple
														inputProps={{
															"aria-labelledby":
																labelId,
														}}
													/>
												</ListItemIcon>
											

											<ListItemText
												primary={
													item.nome_organizacao
														? item.nome_organizacao
														: `${dataR} ${horaR}`
												}
												secondary={
													item.nome_organizacao
														? `${dataR}  ${horaR}`
														: ""
												}
											/>
											</ListItemButton>
										</ListItem>
									);
								})}
							</List>
						</FormGroup>
					</FormControl>
				</div>

				{/* Gráfico Barras */}
				<div
					className="container-fluid col-md-12 col-lg-8"
					style={{ margin: "auto" }}
				>
					<Bar options={options} data={chartData} />
				</div>
			</div>
		</>
	);
}

export default EvolucaoBarra;
